import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "tile is-ancestor" }
const _hoisted_3 = { class: "tile is-parent is-vertical" }
const _hoisted_4 = { class: "tile is-child" }
const _hoisted_5 = { class: "card has-table has-mobile-sort-spaced" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "card-header-title" }, " Videos ", -1)
const _hoisted_8 = { class: "card-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_video_index_table = _resolveComponent("video-index-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("header", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("a", {
                class: _normalizeClass(["card-header-icon", [_ctx.isNewsLoading ? 'disabled' : '']]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerDataReload && _ctx.triggerDataReload(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["icon", {
                    'rotate-infinite is-fast': _ctx.isNewsLoading,
                  }])
                }, [
                  _createVNode(_component_svg_icon, {
                    type: "mdi",
                    path: _ctx.mdiReload
                  }, null, 8, ["path"])
                ], 2)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_video_index_table, {
                "trigger-data-reload": _ctx.dataReload,
                onLoadingData: _cache[1] || (_cache[1] = (e) => (this.isNewsLoading = e))
              }, null, 8, ["trigger-data-reload"])
            ])
          ])
        ])
      ])
    ])
  ]))
}